import { WorkflowTriggerCaption } from "@/pages/workflows/components/WorkflowTriggerCaption.tsx";
import { useWorkflows } from "@/pages/workflows/workflow-hook.tsx";
import { ApiWorkflowListItem, WorkflowRunStatus } from "@/types/workflows/workflow.types.ts";
import {
  Avatar,
  ButtonIcon,
  DropdownMenu,
  DropdownMenuItem,
  FontAwesomeIcon,
  ListItem,
  Stack,
  Tag,
} from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

interface Props {
  workflow: ApiWorkflowListItem;
  runStatus?: WorkflowRunStatus;
  onRemove?: (workflowId: number) => void;
  isBlocking?: boolean;
  onBlockingChange?: (workflowId: number, isBlocking: boolean) => void;
  disabled?: boolean;
}

export function WorkflowSelectedListItem({
  workflow,
  runStatus,
  onRemove,
  isBlocking = false,
  onBlockingChange,
  disabled = false,
}: Props) {
  const { t } = useTranslation();
  const { getWorkflowTriggerTypeIcon, getWorkflowTriggerDescription } = useWorkflows();

  return (
    <ListItem
      icon={
        workflow.is_shared && workflow.emoji ? (
          <Avatar emoji={workflow.emoji} />
        ) : (
          <Avatar icon={getWorkflowTriggerTypeIcon(workflow.trigger_type)} />
        )
      }
      title={workflow.title}
      captionSlot={
        <WorkflowTriggerCaption
          workflow={workflow}
          triggerDescription={getWorkflowTriggerDescription(workflow)}
        />
      }
      forceShowAvatar={true}
      truncate={true}
      valueSlot={
        <Stack direction={"horizontal"} gap={"sm"} items={"center"}>
          {isBlocking && <Tag variant={"warning"}>{t("workflow:blocking_portal_access")}</Tag>}
          {runStatus === "success" && (
            <Tag variant={"positive"}>{t("workflow:workflow_launched")}</Tag>
          )}
          {runStatus === "error" && (
            <Tag variant={"danger"}>{t("workflow:workflow_launch_failed")}</Tag>
          )}
          {!disabled && runStatus !== "success" && (onRemove || onBlockingChange) && (
            <DropdownMenu
              trigger={
                <ButtonIcon
                  variant={"secondary"}
                  icon={<FontAwesomeIcon icon={"fa-light fa-ellipsis"} />}
                />
              }
            >
              {onBlockingChange && (
                <DropdownMenuItem
                  onClick={() => onBlockingChange(workflow.id, !isBlocking)}
                  leftIcon={
                    <FontAwesomeIcon
                      icon={isBlocking ? "fa-light fa-lock-open" : "fa-light fa-lock"}
                    />
                  }
                  title={
                    isBlocking
                      ? t("workflow:block_portal_access_disable")
                      : t("workflow:block_portal_access_enable")
                  }
                />
              )}
              {onRemove && (
                <DropdownMenuItem
                  onClick={() => onRemove(workflow.id)}
                  variant={"menuDanger"}
                  leftIcon={<FontAwesomeIcon icon={"fa-light fa-trash"} />}
                  title={t("common:delete")}
                />
              )}
            </DropdownMenu>
          )}
        </Stack>
      }
    />
  );
}
